import React from 'react';

const FreeTypeDropdownFormatter = ({ value }: { value?: string }) => {
  if (!value) return <div />;

  return <div title={value}>{value}</div>;
};

export default FreeTypeDropdownFormatter;
